<template>
  <div class="soar-container">
    {{ $route.query?.result }}
  </div>
</template>

<script setup></script>

<script>
export default {
  name: 'GatewayCallback'
}
</script>

<style lang="scss" scoped></style>
